import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  padding: 0;
  flex-direction: column;
`;

export const StyledBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  padding: 2rem;
`;

export const IllustrationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  height: 20rem;
  width: 21rem;
  @media only screen and (min-width: 768px) {
    height: 24rem;
    width: 25rem;
  }
  @media only screen and (min-width: 1280px) {
    height: 29rem;
    width: 30rem;
  }
`;

export const StyledButton = styled.button`
  background: ${theme.colors.tenant.main};
  padding: 0.5rem 1.5rem;
  border: 0;
  border-radius: 0.5rem;
  color: #fff;
  &:hover {
    cursor: pointer;
    background: ${theme.colors.tenant.mainAlternate};
  }
  &:disabled {
    cursor: not-allowed;
    background: ${theme.colors.cross.silverFox};
  }
  @media only screen and (min-width: 768px) {
    padding: 0.7rem 2rem;
  }
  @media only screen and (min-width: 1280px) {
    padding: 0.8rem 3rem;
  }
`;
